// API 服务封装
class ApiService {
  constructor() {
    this.baseUrl = 'https://press.eliwise.org/api'
    this.loginUrl = 'https://www.eliresearch.org/api'
    this.token = localStorage.getItem('token') || null
  }

  // 设置 token
  setToken(token) {
    this.token = token
    localStorage.setItem('token', token)
  }

  // 清除 token
  clearToken() {
    this.token = null
    localStorage.removeItem('token')
  }

  // 获取请求头
  getHeaders() {
    const headers = {
      'Content-Type': 'application/json'
    }
    if (this.token) {
      headers['token'] = `${this.token}`
    }
    return headers
  }

  // 通用请求方法
  async request(url, options = {}) {
    try {
      console.log('发送请求到:', url, options)
      
      const response = await fetch(url, {
        ...options,
        headers: this.getHeaders()
      })
      
      console.log('响应状态:', response.status, response.statusText)
      
      const data = await response.json()
      console.log('响应数据:', data)
      
      if (!response.ok) {
        // 如果是401错误，清除token并跳转到登录页
        if (response.status === 401) {
          this.clearToken()
          // 使用window.location跳转，确保页面完全刷新
          window.location.href = '/login'
          return
        }
        throw new Error(data.msg || `请求失败: ${response.status}`)
      }
      
      return data
    } catch (error) {
      console.error('API请求失败:', error)
      console.error('请求URL:', url)
      console.error('请求选项:', options)
      throw error
    }
  }

  // 登录接口
  async login(name, pwd) {
    const response = await this.request(`${this.loginUrl}/article_body_eliwise_login`, {
      method: 'POST',
      body: JSON.stringify({ name, pwd })
    })
    
    if (response.success && response.data.token) {
      this.setToken(response.data.token)
    }
    
    return response
  }

  // 获取期刊列表
  async getJournals(page = 1, pageSize = 20) {
    return await this.request(`${this.baseUrl}/simple/journal/list?page=${page}&page_size=${pageSize}`)
  }

  // 获取卷列表
  async getVolumes(journalId, page = 1, pageSize = 20) {
    return await this.request(`${this.baseUrl}/simple/volume/list?journal_id=${journalId}&page=${page}&page_size=${pageSize}`)
  }

  // 获取文章列表
  async getArticles(volumeId, page = 1, pageSize = 20) {
    return await this.request(`${this.baseUrl}/simple/article/list?volume_id=${volumeId}&page=${page}&page_size=${pageSize}`)
  }

  // 搜索文章
  async searchArticles(search, volumeId = null, page = 1, pageSize = 20) {
    const params = new URLSearchParams({
      search,
      page,
      page_size: pageSize
    })
    
    if (volumeId) {
      params.append('volume_id', volumeId)
    }
    
    return await this.request(`${this.baseUrl}/simple/article/list?${params}`)
  }

  // 获取文章内容
  async getArticleBody(articleId) {
    return await this.request(`${this.baseUrl}/simple/article/body?article_id=${articleId}`)
  }

  // 保存文章内容
  async saveArticleBody(articleId, bodyHtml) {
    return await this.request(`${this.baseUrl}/simple/article/save_body`, {
      method: 'POST',
      body: JSON.stringify({
        article_id: articleId,
        body_html: bodyHtml
      })
    })
  }

  // 确认文章
  async confirmArticle(articleId) {
    return await this.request(`${this.baseUrl}/simple/article/confirm_body`, {
      method: 'POST',
      body: JSON.stringify({
        article_id: articleId
      })
    })
  }

  // 上传图片
  async uploadImage(file) {
    const formData = new FormData()
    formData.append('file', file)
    
    // 对于文件上传，不设置 Content-Type，让浏览器自动设置
    const headers = {}
    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`
    }
    
    const response = await fetch(`${this.baseUrl}/markdown/upload`, {
      method: 'POST',
      body: formData,
      headers
    })
    
    const data = await response.json()
    
    if (!response.ok) {
      throw new Error(data.msg || '上传失败')
    }
    
    return data
  }
}

// 创建单例实例
const apiService = new ApiService()

export default apiService 